import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

export default function MoreOptionsMenu({ onImportSKUs, onAddNewSKU, onExportSKUs, creating }) {
  const handleImportSKUs = popupState => {
    onImportSKUs();
    popupState.close();
  };

  const handleAddNewSKU = async popupState => {
    await onAddNewSKU();
    popupState.close();
  };

  const handleExportSKUs = popupState => {
    onExportSKUs();
    popupState.close();
  };

  return (
    <Box display="flex" justifyContent="flex-end" mb={2}>
      <PopupState variant="popover" popupId="more-options-menu">
        {popupState => (
          <>
            <ButtonBase aria-label="more options" {...bindTrigger(popupState)}>
              {creating ? <CircularProgress size={18} sx={{ mr: 0.5 }} /> : <MoreVertIcon />} More
              Options
            </ButtonBase>
            <Menu id="more-options-menu" {...bindMenu(popupState)}>
              <MenuItem onClick={() => handleAddNewSKU(popupState)}>
                <ListItemIcon>
                  <AddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Add New SKU" />
              </MenuItem>
              <MenuItem onClick={() => handleImportSKUs(popupState)}>
                <ListItemIcon>
                  <FileUploadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Import SKUs" />
              </MenuItem>
              <MenuItem onClick={() => handleExportSKUs(popupState)}>
                <ListItemIcon>
                  <FileDownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Export SKUs" />
              </MenuItem>
            </Menu>
          </>
        )}
      </PopupState>
    </Box>
  );
}
